<template>
    <v-dialog
        :value="show"
        class="am-add-user-dialog"
        width="500"
        @input="($event) => $emit('updateShow', $event)"
    >
        <v-card>
            <v-card-title class="am-add-user-dialog__title">
                Add New User
            </v-card-title>

            <v-card-text>
                <h3>Username:</h3>
                <v-text-field
                    v-model="username"
                    type="text"
                />
            </v-card-text>

            <v-card-text>
                <h3>Email:</h3>
                <v-text-field
                    v-model="email"
                    type="email"
                />
            </v-card-text>

            <v-card-text>
                <h3>Password:</h3>
                <v-text-field
                    v-model="password"
                    type="password"
                />
            </v-card-text>

            <v-card-text>
                <h3>Assign to Group:</h3>
                <v-autocomplete
                    v-model="selectedGroupId"
                    :items="groups"
                    :search-input.sync="groupSearch"
                    :loading="groupsLoading"
                    item-text="name"
                    item-value="id"
                    label="Select a group (optional)"
                    clearable
                    no-filter
                    @update:search-input="onGroupSearch"
                />
            </v-card-text>

            <v-card-actions class="am-add-user-dialog__buttons">
                <v-btn
                    color="primary"
                    text
                    @click.stop="emitSave"
                >
                    Save
                </v-btn>
                <v-btn
                    color="grey"
                    text
                    @click.stop="$emit('cancel')"
                >
                    Cancel
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import _ from 'lodash';
import Dependencies from '@/dependencyContainer/dependenciesList';

export default {
    name: 'AddUserDialog',
    model: {
        prop: 'show',
        event: 'updateShow'
    },
    props: {
        show: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            showDialog: false,
            username: '',
            email: '',
            password: '',
            selectedGroupId: null,
            groupSearch: '',
            groups: [],
            groupsLoading: false,
            debouncedFetchGroups: _.debounce(this.fetchGroups, 400)
        };
    },
    watch: {
        show(val) {
            this.showDialog = val;
            if (val) {
                this.fetchGroups();
            } else {
                this.resetForm();
            }
        }
    },
    methods: {
        onGroupSearch(value) {
            this.debouncedFetchGroups(value);
        },

        async fetchGroups(search = '') {
            this.groupsLoading = true;
            try {
                const userGroupReq = await this.$dc.get(Dependencies.UserGroupRequests);
                const params = search ? { pattern: search } : {};
                this.groups = await userGroupReq.queryUserGroups(params);
            } catch (e) {
                this.groups = [];
            } finally {
                this.groupsLoading = false;
            }
        },

        emitSave() {
            const payload = {
                username: this.username,
                email: this.email,
                password: this.password
            };

            if (this.selectedGroupId) {
                payload.groupId = this.selectedGroupId;
            }

            this.$emit('save', payload);
        },

        resetForm() {
            this.username = '';
            this.email = '';
            this.password = '';
            this.selectedGroupId = null;
            this.groupSearch = '';
        }
    }
};
</script>

<style lang="scss" scoped>

  .am-add-user-dialog {
    &__title {
      font-weight: bold;
    }
  }

</style>
